'use client';

import { useLayoutEffect, useEffect, useState } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { Link } from '@/components/ui/link/link.component';

function consentState(value: 'granted' | 'denied') {
  return {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
    functionality_storage: value,
    personalization_storage: value,
    security_storage: value,
  };
}

export default function CookiesFooter() {
  const [{ accepted }, setCookieConsent] = useLocalStorage<{ accepted: boolean }>('cookie-consent', { accepted: false });
  const [isMounted, setIsMounted] = useState<boolean>(false);

  useLayoutEffect(() => {
    window.dataLayer = window.dataLayer || [];

    window.gtag = window.gtag || function () {
      window.dataLayer?.push(arguments);
    }

    window.gtag('consent', 'default', consentState('denied'));

    setIsMounted(true);
  }, []);

  const acceptCookies = () => {
    setCookieConsent({ accepted: true });
  };

  useEffect(() => {
    const update = consentState(accepted ? 'granted' : 'denied');

    window.gtag('consent', 'update', update);

    window.gtag('event', 'consent.update', update);
  }, [accepted]);

  if (!isMounted || accepted) {
    return null;
  }

  return (
    <div className="fixed bottom-0 bg-white shadow-modal w-full p-5 md:p-6 lg:p-8 z-40 pointer-events-auto">
      <div
        className="flex flex-col md:flex-row justify-between gap-6 md:mx-auto md:max-w-3xl lg:max-w-4xl xl:max-w-5xl 3xl:max-w-7xl"
      >
        <p data-testid={DataTestIdEnum.COOKIES_FOOTER_TEXT} className="text-gray-800 font-light">
          Para melhorar sua experiência, utilizamos cookies. Ao aceitar, você concorda com nossa
          {' '}
          <Link href="/politica-de-privacidade/" className="text-green-500 font-semibold hover:underline">
            Política de Privacidade
          </Link>
          {' '}
          e terá acesso total ao site.
        </p>

        <Button
          data-testid={DataTestIdEnum.COOKIES_FOOTER_BUTTON}
          className="w-full md:w-[12.5rem] h-[3rem]"
          onClick={acceptCookies}
        >
          Aceitar cookies
        </Button>
      </div>
    </div>
  );
}
